module.exports = __webpack_public_path__ + "static/media/advocatia_full.7dbc06d3.png";